import { Grid } from '@mui/material';
import { Checkbox, HSpacer, RoutalDialog } from '@nx-smartmonkey/ui';
import { useEffect, useState } from 'react';

import {
  ProjectPlannerStopFieldsType,
  ProjectPlannerTaskFieldsType,
  ProjectPlannerVehicleFieldsType,
} from '../../../../domain/project/projectPlanner/ProjectPlannerFields';
import Button from '../../../../react-components/Button';
import Text from '../../../../react-components/Text';

export interface AppField {
  id: string;
  text: string;
  type: ProjectPlannerVehicleFieldsType | ProjectPlannerStopFieldsType | ProjectPlannerTaskFieldsType;
  is_custom_field: boolean;
  is_required?: boolean;
}

interface ManageFieldsDialogProps {
  open: boolean;
  unassignedFields: AppField[];
  onUpdate: (props: { newFields: AppField[] }) => void;
  onClose: () => void;
}

export const ManageFieldsDialog = ({ open, unassignedFields, onUpdate, onClose }: ManageFieldsDialogProps) => {
  const [selectedFields, setSelectedFields] = useState<AppField[]>([]);

  const areAllSelected = selectedFields.length === unassignedFields.length;

  useEffect(() => {
    setSelectedFields([]);
  }, [open]);

  return (
    <RoutalDialog
      open={open}
      onCloseDialog={() => onClose()}
      titleContent={<Text variant="h6" intlId="planner.add_fields" />}
      showFooter={false}
      contentStyles={{
        padding: 0,
      }}
    >
      <Grid container direction="column">
        <Grid
          item
          style={{ maxHeight: `600px`, minHeight: `120px`, overflowY: `auto`, padding: `16px`, paddingTop: 0 }}
        >
          <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="flex-end"
            key="select-all"
            style={{
              height: `42px`,
              padding: `0 8px`,
            }}
          >
            <Grid item>
              <Text
                variant="label"
                style={{ fontSize: `13px` }}
                intlId="planner.add_fields.num_selected"
                intlValues={{ num: selectedFields.length }}
              />
            </Grid>

            <HSpacer small />

            <Grid item>
              <Text
                variant="button"
                intlId={`planner.add_fields.${areAllSelected ? `unselect_all` : `select_all`}`}
                onClick={() => {
                  setSelectedFields(areAllSelected ? [] : unassignedFields);
                }}
              />
            </Grid>
          </Grid>

          {unassignedFields.map((field, index) => (
            <Grid
              container
              direction="row"
              alignItems="center"
              key={field.id}
              style={{
                height: `42px`,
                padding: `0 8px`,
                ...(index > 0 ? { borderTop: `1px solid #E0E0E0` } : {}),
              }}
            >
              <Grid item xs={10}>
                <Text>{field.text}</Text>
              </Grid>

              <Grid item container xs={2} justifyContent="end">
                <Checkbox
                  checked={selectedFields.map((field) => field.id).includes(field.id)}
                  onChange={(event: any) => {
                    const { checked } = event.target;
                    if (checked) {
                      setSelectedFields([...selectedFields, field]);
                    } else {
                      setSelectedFields(selectedFields.filter((f) => f.id !== field.id));
                    }
                  }}
                />
              </Grid>
            </Grid>
          ))}

          <Grid container direction="row" justifyContent="flex-end" style={{ marginTop: `8px` }}>
            <Button
              disabled={selectedFields.length === 0}
              intlId="save"
              onClick={() => {
                onUpdate({ newFields: selectedFields });
                onClose();
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </RoutalDialog>
  );
};
